<template>
	<div class="row">
		<h5 class="filter-text">{{ $t("filterBy:") }}</h5>
		<v-card flat class="col-12 p-3">
			<form class="row" @submit.prevent="filterData">
				<div class="col-lg-3">
					<v-text-field
						v-model.lazy="filter.studentName"
						:label="$t('studentName')"
						filled
						clearable
						color="green"
						clear-icon="mdi-close-circle"
					></v-text-field>
				</div>
				<div class="col-lg-3">
					<v-text-field
						v-model.lazy="filter.tutorName"
						:label="$t('tutorName')"
						filled
						clearable
						color="green"
						clear-icon="mdi-close-circle"
					></v-text-field>
				</div>
				<div class="col-lg-3">
					<v-dialog
						ref="startDateDialog"
						v-model="startDateModal"
						:return-value.sync="filter.startDate"
						width="300px"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								v-model="filter.startDate"
								:label="$t('Start_Date')"
								filled
								color="green"
								prepend-icon="mdi-calendar"
								v-bind="attrs"
								v-on="on"
								clearable
								clear-icon="mdi-close-circle"
							></v-text-field>
						</template>
						<v-date-picker v-model="filter.startDate" color="green">
							<v-spacer></v-spacer>
							<v-btn text color="red" @click="startDateModal = false">
								{{ $t("Cancel") }}
							</v-btn>
							<v-btn
								text
								color="green"
								@click="$refs.startDateDialog.save(filter.startDate)"
							>
								{{ $t("ok") }}
							</v-btn>
						</v-date-picker>
					</v-dialog>
				</div>
				<div class="col-lg-3">
					<v-dialog
						ref="requestedDateDialog"
						v-model="requestedDateModal"
						:return-value.sync="filter.requestedDate"
						width="300px"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								v-model="filter.requestedDate"
								:label="$t('requestedDate')"
								filled
								color="green"
								prepend-icon="mdi-calendar"
								v-bind="attrs"
								v-on="on"
								clearable
								clear-icon="mdi-close-circle"
							></v-text-field>
						</template>
						<v-date-picker v-model="filter.requestedDate" color="green">
							<v-spacer></v-spacer>
							<v-btn text color="red" @click="requestedDateModal = false">
								{{ $t("Cancel") }}
							</v-btn>
							<v-btn
								text
								color="green"
								@click="$refs.requestedDateDialog.save(filter.requestedDate)"
							>
								{{ $t("ok") }}
							</v-btn>
						</v-date-picker>
					</v-dialog>
				</div>
				<div
					class="col d-flex justify-content-center md-justify-content-end align-items-center mb-1"
				>
					<v-btn color="success" type="submit" class="me-4">
						{{ $t("search") }}
					</v-btn>
					<v-btn color="error" @click="resetFilter">
						{{ $t("clear") }}
					</v-btn>
				</div>
			</form>
		</v-card>
	</div>
</template>

<script>
import GlobalMixin from "@/GlobalMixin.js";

export default {
	name: "SearchBox",
	mixins: [GlobalMixin],
	data() {
		return {
			// Filter Parameters
			filter: {
				studentName: "",
				tutorName: "",
				startDate: null,
				requestedDate: null,
			},

			startDateModal: false,
			requestedDateModal: false,
		};
	},
	methods: {
		filterData() {
			this.$emit("filterData", this.filter);
		},
		resetFilter() {
			this.filter = {
				studentName: "",
				tutorName: "",
				startDate: null,
				requestedDate: null,
			};
			this.$emit("resetFilter");
		},
	},
};
</script>

<style lang="scss">
.filter-text {
	color: #9f9f9f;
	margin-top: 1rem;
}
</style>
